// extracted by mini-css-extract-plugin
module.exports = {"fade":"Fade_fade__C1_WX","fade__container":"Fade_fade__container__yF7v6"};